import { Controller } from "@hotwired/stimulus"

// "Added plates" modal on a customer's session page: the plates the restaurant
// asked for on the day, each next to the delivered pictures named after it.
// The pictures are matched server-side (ShootingMenuItem.pictures_by_plate)
// and fetched once, the first time the modal opens.
export default class extends Controller {
  static targets = ["pics"]
  static values = { url: String, none: String, unavailable: String }

  connect() {
    this.loaded = false
    this.modalEl = this.element.closest(".modal")
    this.onShow = () => this.load()
    if (this.modalEl) this.modalEl.addEventListener("show.bs.modal", this.onShow)
  }

  disconnect() {
    if (this.modalEl) this.modalEl.removeEventListener("show.bs.modal", this.onShow)
  }

  async load() {
    if (this.loaded || !this.urlValue) return
    this.loaded = true
    try {
      const res = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      const data = await res.json()
      if (data.error && data.error !== "no_folder") return this.fill({}, this.unavailableValue)
      this.fill(data.plates || {}, this.noneValue)
    } catch (_e) {
      this.loaded = false
      this.fill({}, this.unavailableValue)
    }
  }

  fill(plates, emptyText) {
    this.picsTargets.forEach((box) => {
      const pics = plates[box.dataset.plateId] || []
      box.replaceChildren()
      if (pics.length === 0) {
        const empty = document.createElement("span")
        empty.className = "added-plate__empty"
        empty.textContent = emptyText
        box.appendChild(empty)
        return
      }
      pics.forEach((pic) => {
        const link = document.createElement("a")
        link.href = pic.url
        link.target = "_blank"
        link.rel = "noopener"
        link.className = "added-plate__pic"
        const img = document.createElement("img")
        img.src = pic.url
        img.alt = pic.name
        img.loading = "lazy"
        link.appendChild(img)
        box.appendChild(link)
      })
    })
  }
}
